import { Injectable } from '@angular/core'
import { FirestoreService } from '../../shared/modules/fire/firestore.service'
import { ShopSettings } from '../../../../domain/user/shop-settings.model'
import { Observable, of } from 'rxjs'
import { FirestoreQueryConstraintsBuilder } from '../../shared/modules/fire/firestore/list/firestore-query-constraints-builder'
import { FirestoreFilter } from '../../shared/modules/fire/firestore/list/firestore-filter'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class ShopSettingsFirestoreService extends FirestoreService<ShopSettings> {
	constructor() {
		super()
	}

	getByShopUrl(shopUrl: string): Observable<ShopSettings | null> {
		if (!shopUrl) {
			return of(null)
		}
		const queryConstraints = FirestoreQueryConstraintsBuilder.withFilters([
			FirestoreFilter.equals('url', shopUrl),
		]).build()
		return this.read(queryConstraints).pipe(map((settings) => settings?.shift() ?? null))
	}

	protected resolvePath(): string {
		return 'shop-settings'
	}
}
